import { type RefObject, useEffect } from 'react';

import { FOCUSABLE_SELECTOR } from './useFocusTrap';

export function useScrollAreaTabStop(scrollAreaRef: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const scrollArea = scrollAreaRef.current;
    if (!scrollArea) return;
    if (scrollArea.querySelector(FOCUSABLE_SELECTOR)) scrollArea.tabIndex = -1;
    else scrollArea.removeAttribute('tabindex');
  });
}
